$(document).ready(() => {
  const breakpoint = 400; // Define your breakpoint in pixels
  const $slider = $('#price-cards-slider');

  function initializeSlick() {
    $slider.slick({
      arrows: false,
      infinite: false,
      slidesToShow: 1.12,
      slidesToScroll: 1,
      autoplay: false,
      dots: false,
      // centerMode: true,
      // Add this to prevent sliding on desktop
      cssEase: 'linear', // Ensures smooth transitions
    });
  }

  function handleResize() {
    if ($(window).width() <= breakpoint) {
      if (!$slider.hasClass('slick-initialized')) {
        initializeSlick(); // Initialize Slick Slider on mobile
      }
    } else {
      if ($slider.hasClass('slick-initialized')) {
        $slider.slick('unslick'); // Destroy Slick Slider on desktop
      }
    }
  }

  // Initial check
  handleResize();

  // Check on window resize
  $(window).on('resize', function() {
    handleResize();
  });
});
